import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./Main";
import { japanImpact2025 } from "./config/JapanImpact/2025";
import { polylan } from "./config/PolyLAN";
import "./config/JapanImpact/2026";
import * as ji17 from "./config/JapanImpact/2026";
import * as ji18 from "./config/JapanImpact/2027";

export default function FoxDen() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/JI/2025" element={<Main content={japanImpact2025} />} />
        <Route path="/JI/2026" element={<Main content={ji17.hermine} />} />
        <Route path="/JI" element={<Main content={ji18.hermine} />} />
        <Route path="/PL" element={<Main content={polylan} />} />
      </Routes>
    </BrowserRouter>
  );
}
